import { ReactNode } from 'react';
import Confetti from 'react-confetti-boom';

const CelebrationModal: React.FC<{
  children: ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return (
    <div className={className}>
      <Confetti
        y={1}
        particleCount={50}
        shapeSize={20}
        effectCount={2}
        effectInterval={300}
        launchSpeed={2.7}
      />
      {children}
    </div>
  );
};

export default CelebrationModal;
